import React from 'react';
import { Link } from 'react-router-dom';

function TeacherNavbar() {

  return(<></>);

  // return (
  //   <ul className="nav-items">
  //     <li className="nav-item">
  //       <Link to="/teacher/dashboard">Dashboard</Link>
  //     </li>
  //     <li className="nav-item">
  //       <Link to="/scan">Scan Document</Link>
  //     </li>
  //     <li className="nav-item">
  //       <Link to="/profile">Profile</Link>
  //     </li>
  //   </ul>
  // );
}

export default TeacherNavbar;